// noinspection ES6PreferShortImport

import { RecordType } from '@petconsole/pure-base';
import { anySite } from '../../constants';
import { entityCategory, entityName, entityTabName } from '../../entity/constants';
import entityAttributes from '../../entity/entityAttributes';
import entitySchema from '../../entity/entitySchema';
import initialEntity from '../../entity/initialEntity';
import { schema } from '../../entity/schema';
import { DataEntityType, InitialEntity, MaybeNull, RatingBusinessColumns, SubscribeColumns } from '../../types';

interface VanSupply extends RatingBusinessColumns, SubscribeColumns {
  type: DataEntityType;
  vanSupplyId: string;
  name: string;
}

const { General, Details, Avatar, Banner, Photos, Comments, Preview } = entityTabName;
export const vanSupplyEntity = entityAttributes({
  name: entityName.vanSupply,
  attributes: {
    category: entityCategory.business,
    columns: { address: true, business: true, rating: true, socials: true, subscribe: true },
    loadLimit: 20,
    maxImages: 12,
    plural: `vanSupplies`,
    site: anySite.busConsole,
    subscribable: true,
    tabs: [General, Details, Avatar, Banner, Photos, Comments, Preview],
  },
});

const { strim } = schema;
export const vanSupplySchema = entitySchema<VanSupply>(vanSupplyEntity, {
  name: strim().required('Business name is required'),
});

export const vanSupplyDefaults: Partial<VanSupply> = {
  name: '',
};

export interface VanSupplyRecord extends VanSupply, RecordType {}

export type MaybeVanSupplyRecord = MaybeNull<VanSupplyRecord>;
export type VanSupplyRecords = VanSupplyRecord[];

export const initialVanSupply: InitialEntity<VanSupply, VanSupplyRecord> = (overrides = {}) =>
  initialEntity<VanSupply>(vanSupplyEntity, { ...vanSupplyDefaults, ...overrides }) as VanSupplyRecord;
